/**
 * Lightweight event bus for global toast notifications.
 * Allows non-React code (e.g. QueryClient error handlers) to trigger toasts.
 * ToastProvider subscribes; any module can emit.
 */

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastEvent {
  type: ToastType;
  title: string;
  message?: string;
}

type ToastListener = (event: ToastEvent) => void;

const listeners = new Set<ToastListener>();

export const toastBus = {
  subscribe(listener: ToastListener) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
  emit(type: ToastType, title: string, message?: string) {
    const event: ToastEvent = { type, title, message };
    listeners.forEach((fn) => fn(event));
  },
};
